import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8f31c34c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tab-wrap" };
import Tab from '../atoms/Tab.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        contents: null,
        checkedIndex: { default: 0 },
        labels: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const onTabClick = (value) => {
            emit('click', value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.contents, (content, index) => {
                    return (_openBlock(), _createBlock(Tab, {
                        key: index,
                        index: index,
                        groupName: content.groupName,
                        label: props.labels[index],
                        checkedIndex: props.checkedIndex,
                        onClick: ($event) => (onTabClick(content.value))
                    }, null, 8, ["index", "groupName", "label", "checkedIndex", "onClick"]));
                }), 128))
            ]));
        };
    }
});
